export default {
  BASE_URL: '/crm',
  api: [
    {
      name: 'busList',
      desc: '业务销售列表',
      method: 'POST',
      path: '/busSalesManange/list'
    },
    {
      name: 'getProjFile',
      desc: '查看供货协议',
      method: 'GET',
      path: '/busSalesManange/getProjFile'
    },
    {
      name: 'initPayments',
      desc: '初始化项目结算方式窗体',
      method: 'GET',
      path: '/busSalesManange/initPayments'
    },
    {
      name: 'initPeriods',
      desc: '获取月结账期',
      method: 'GET',
      path: '/busSalesManange/initPeriods'
    },
    {
      name: 'getProjPayments',
      desc: '获取项目已选中的结算方式',
      method: 'GET',
      path: '/busSalesManange/getProjPayments'
    },
    {
      name: 'saveProjPayments',
      desc: '保存项目的结算方式',
      method: 'POST',
      path: '/busSalesManange/saveProjPayments'
    },
    {
      name: 'downloadProjFile',
      desc: '下载供货协议模板',
      method: 'GET',
      path: '/busSalesManange/downloadProjFile'
    },
    {
      name: 'uploadProjFile',
      desc: '上传供货协议',
      method: 'POST',
      path: '/busSalesManange/uploadProjFile'
    },
    {
      name: 'saveLiquidated',
      desc: '违约金计算规则保存或更新',
      method: 'POST',
      path: '/liquidated/damages/save'
    },
    {
      name: 'detailLiquidated',
      desc: '违约金计算规则详情',
      method: 'GET',
      path: '/liquidated/damages/details'
    },
    {
      name: 'unit',
      desc: '单位选项',
      method: 'GET',
      path: 'liquidated/damages/list/unit'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/sales/business.js